// extracted by mini-css-extract-plugin
export default {"list":"GameBlogPostList_list__EnDnL"};